import { useQuery } from '@tanstack/react-query'
import { adminApi, ArtworkSearchParams } from '../api/adminApi'
import type { PaginationParams } from '@/types/common'

export function useArtworkSearch(
  params: ArtworkSearchParams,
  pagination: PaginationParams,
  enabled: boolean = true
) {
  return useQuery({
    queryKey: ['admin', 'artworks', 'search', params, pagination],
    queryFn: () => adminApi.searchArtworks(params, pagination),
    enabled,
  })
}

export function useAdminArtists() {
  return useQuery({
    queryKey: ['admin', 'artists'],
    queryFn: adminApi.getArtists,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}

export function useAdminTags() {
  return useQuery({
    queryKey: ['admin', 'tags'],
    queryFn: adminApi.getTags,
    staleTime: 30 * 60 * 1000, // 30 minutes
  })
}
